<h2 mat-dialog-title style="font-size: x-large;">{{'D_T4' | translate}}</h2>
<mat-dialog-content class="mat-typography">
    <div>
        <p>
            {{'D_P6' | translate}}
        </p>
        <p>
            {{'D_P7' | translate}}
        </p>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button style="font-size: large;" mat-button mat-dialog-close>Ok</button>
</mat-dialog-actions>